// import React, { useState, useEffect, useCallback, useContext } from "react";
// import Select from "react-select";
// import {
//   Button,
//   Form,
//   FormGroup,
//   Label,
//   Card,
//   CardBody,
//   CardFooter,
//   Row,
//   Col,
//   Input,
// } from "reactstrap";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addCandidate,
//   fetchCandidateRequest,
//   resetAddCandidate,
// } from "../../../redux/recruiter/add_candidate/actions";
// import { fetchLocationsRequest } from "../../../redux/location/actions";
// import { showToast } from "../../../Components/Common/Toast";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   customOptionsStyle,
//   experienceOptions,
//   monthsOptions,
// } from "../../../Constant";
// import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
// import {
//   extractAfterLastHyphen,
//   countryPhoneLengthMap,
// } from "../../Common/CommonFunction";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css"; // Import styles directly from react-phone-input-2
// import validator from "validator";
// import { AuthContext } from "../../../Auth/AuthContext";

// const AddCandidate = () => {
//   const dispatch = useDispatch();
//   const { triggerTotalPoints } = useContext(AuthContext);
//   const { job_id, cand_id } = useParams();
//   const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(10); // Default max length for phone1
//   const [phoneNumber2MaxLength, setPhoneNumber2MaxLength] = useState(10); // Default max length for phone2
//   const navigate = useNavigate();
//   const [locationOptions, setLocationOptions] = useState([]);
//   const [formData, setFormData] = useState({
//     full_name: "",
//     email1: "",
//     email2: "",
//     country_code1: "91",
//     country_code2: "91",
//     phone1: "",
//     phone2: "",
//     jobseeker_location: null,
//     relevant_experience_years: null,
//     relevant_experience_months: null,
//   });

//   const [errors, setErrors] = useState({});
//   const addCandidateReducerData = useSelector(
//     (state) => state.addCandidateReducer
//   );

//   // Fetching and updating location data
//   let locationReducerData = useSelector((state) => state.locationReducer);
//   let locationData = locationReducerData.data.data;

//   useEffect(() => {
//     locationData = locationData || [];
//     setLocationOptions(locationData);
//   }, [locationData]);

//   const handleLocationFocus = () => {
//     const fetchData = async () => {
//       try {
//         const keyword = ""; // Set your keyword value here
//         dispatch(fetchLocationsRequest(keyword));
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchData();
//   };

//   const handleLocationInputChange = useCallback((inputValue) => {
//     const fetchData = async () => {
//       try {
//         dispatch(fetchLocationsRequest(inputValue));
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleLocationsChange = (selectedOptions) => {
//     const updatedErrors = { ...errors, jobseeker_location: "" };
//     setErrors(updatedErrors);
//     setFormData({ ...formData, jobseeker_location: selectedOptions });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const updatedErrors = { ...errors, [name]: "" };
//     setErrors(updatedErrors);
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const { name } = e.nativeEvent.submitter;

//     if (validate()) {
//       const payload = {
//         jobseeker_full_name: formData.full_name,
//         jobseeker_email1: formData.email1,
//         jobseeker_email2: formData.email2,
//         country_code1: formData.country_code1,
//         country_code2: formData.country_code2,
//         jobseeker_phone1: formData.phone1,
//         jobseeker_phone2: formData.phone2,
//         jobseeker_location: formData.jobseeker_location
//           ? formData.jobseeker_location.value
//           : null,
//         month_exp: formData.relevant_experience_months
//           ? formData.relevant_experience_months.value
//           : null,
//         year_exp: formData.relevant_experience_years
//           ? formData.relevant_experience_years.value
//           : null,
//         job_id: extractAfterLastHyphen(job_id),
//         //seeker_id: cand_id,
//         type: name,
//       };

//       dispatch(addCandidate(payload));

//       //navigate(`/recruiter/job_candidate_detail/${cand_id}`); // Redirect to the desired path
//     } else {
//       console.error("Form submission error:", errors);
//     }
//   };

//   const validate = () => {
//     let errors = {};
//     let isValid = true;

//     if (!formData.full_name) {
//       errors.full_name = "Full name is required";
//       isValid = false;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,6}$/;
//     if (!formData.email1) {
//       errors.email1 = "Email is required";
//       isValid = false;
//     } else if (!emailRegex.test(formData.email1)) {
//       errors.email1 = "Please enter valid email";
//       isValid = false;
//     }

//     if (formData.email2 && !emailRegex.test(formData.email2)) {
//       errors.email2 = "Please enter valid email";
//       isValid = false;
//     }

//     const trimmedPhoneNumber = formData.phone1.trim();
//     if (!trimmedPhoneNumber) {
//       errors.phone1 = "Phone number is required";
//       isValid = false;
//     } else if (
//       formData.country_code1 === "91" &&
//       trimmedPhoneNumber.length !== 10
//     ) {
//       errors.phone1 = "Phone number must be 10 digits for india";
//       isValid = false;
//     } else if (isNaN(trimmedPhoneNumber)) {
//       errors.phone1 = "Phone number must be a valid number";
//       isValid = false;
//     } else if (
//       !validator.isMobilePhone(trimmedPhoneNumber, "any", { strictMode: false })
//     ) {
//       errors.phone1 = "Invalid phone number format";
//       isValid = false;
//     }

//     const trimmedPhoneNumber2 = formData.phone2.trim();
//     if (trimmedPhoneNumber2) {
//       // Check if phone2 is provided
//       if (
//         formData.country_code2 === "91" &&
//         trimmedPhoneNumber2.length !== 10
//       ) {
//         errors.phone2 = "Phone number must be 10 digits for India";
//         isValid = false;
//       } else if (isNaN(trimmedPhoneNumber2)) {
//         errors.phone2 = "Phone number must be a valid number";
//         isValid = false;
//       } else if (
//         !validator.isMobilePhone(trimmedPhoneNumber2, "any", {
//           strictMode: false,
//         })
//       ) {
//         errors.phone2 = "Invalid phone number format";
//         isValid = false;
//       }
//     }

//     if (!formData.jobseeker_location) {
//       errors.jobseeker_location = "Current location is required";
//       isValid = false;
//     }

//     if (
//       !formData.relevant_experience_years &&
//       !formData.relevant_experience_months
//     ) {
//       errors.relevant_experience_years =
//         "Relevant Experience (either in years or months) is required";
//       isValid = false;
//     }

//     setErrors(errors);
//     return isValid;
//   };

//   useEffect(() => {
//     console.log("addCandidateReducerData:", addCandidateReducerData);
//     if (
//       addCandidateReducerData.status === true &&
//       addCandidateReducerData.message !== ""
//     ) {
//       showToast("success", addCandidateReducerData.message);
//       triggerTotalPoints("add_candidate", false);
//       const seeker_id = addCandidateReducerData.seeker_id;
//       const job_cand_id = addCandidateReducerData.job_cand_id;

//       if (seeker_id && job_cand_id) {
//         navigate(
//           `${process.env.PUBLIC_URL}/recruiter/job_candidate_detail/edit/${seeker_id}/${job_cand_id}`
//         );
//       } else {
//         navigate(`${process.env.PUBLIC_URL}/recruiter/manage_candidate`);
//       }
//       dispatch(resetAddCandidate());
//     } else if (
//       addCandidateReducerData.status === false &&
//       addCandidateReducerData.message !== ""
//     ) {
//       showToast("error", addCandidateReducerData.message);
//       dispatch(resetAddCandidate());
//     }
//   }, [addCandidateReducerData, navigate, dispatch]);

//   const handleCodeChange = (value, country) => {
//     // Extract only the phone number without the country code
//     const phoneNumberWithoutCode = value
//       .replace(`+${country.dialCode}`, "")
//       .trim();
//     // Removing non-digit characters and ensuring country code is included
//     const formattedPhoneNumber = `+${country.dialCode}${value
//       .replace(/\D/g, "")
//       .slice(country.dialCode.length)}`;
//     setFormData({
//       ...formData,

//       country_code1: country.dialCode,
//       jobseeker_phone1: "", // Resetting phone field when country changes, optional
//     });
//     // Update max length based on the selected country code
//     const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15; // default to 15 if not found
//     setPhoneNumberMaxLength(newMaxLength); // This assumes you have a state that holds the max length
//   };
//   const handleCodeChange2 = (value, country) => {
//     // Extract only the phone number without the country code
//     const phoneNumberWithoutCode = value
//       .replace(`+${country.dialCode}`, "")
//       .trim();
//     // Removing non-digit characters and ensuring country code is included
//     const formattedPhoneNumber = `+${country.dialCode}${value
//       .replace(/\D/g, "")
//       .slice(country.dialCode.length)}`;
//     setFormData({
//       ...formData,

//       country_code2: country.dialCode,
//       jobseeker_phone2: "", // Resetting phone field when country changes, optional
//     });

//     // Update max length based on the selected country code
//     const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15;
//     setPhoneNumber2MaxLength(newMaxLength);
//   };

//   return (
//     <Form onSubmit={handleSubmit} className="theme-form">
//       <Card>
//         <CardBody>
//           <Row>
//             <Col md={6}>
//               <FormGroup>
//                 <Label for="full_name">
//                   Full Name
//                   <span className="text-danger">*</span>
//                 </Label>
//                 <Input
//                   maxLength={50} // Set the character limit here
//                   className="form-control form-control-sm"
//                   type="text"
//                   name="full_name"
//                   id="full_name"
//                   placeholder="Enter full name"
//                   value={formData.full_name}
//                   onChange={(e) => {
//                     const { value } = e.target;

//                     // Validates if the input value contains only alphabetic characters (and spaces)
//                     if (/^[A-Za-z\s]*$/.test(value) && value.length <= 50) {
//                       handleChange(e); // Call your existing handleChange function
//                     } else {
//                       // Optionally, set an error message or provide feedback
//                       const updatedErrors = {
//                         ...errors,
//                         full_name: "Only alphabetic characters are allowed.",
//                       };
//                       setErrors(updatedErrors);
//                     }
//                   }}
//                 />
//                 {errors.full_name && (
//                   <small className="text-danger">{errors.full_name}</small>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col md="6">
//               <FormGroup>
//                 <Label>
//                   Current Location
//                   <span className="text-danger">*</span>
//                 </Label>
//                 <Select
//                   name="jobseeker_location"
//                   options={locationOptions}
//                   isLoading={locationReducerData.isLoading}
//                   placeholder="Select locations..."
//                   value={formData.jobseeker_location}
//                   onChange={handleLocationsChange}
//                   onInputChange={handleLocationInputChange}
//                   styles={customOptionsStyle}
//                   onFocus={handleLocationFocus}
//                 />
//                 {errors.jobseeker_location && (
//                   <small className="text-danger">
//                     {errors.jobseeker_location}
//                   </small>
//                 )}
//               </FormGroup>
//             </Col>
//           </Row>
//           <Row>
//             <Col md={6}>
//               <FormGroup>
//                 <Label>
//                   Primary Phone
//                   <span className="text-danger">*</span>
//                 </Label>
//                 <div className="d-flex">
//                   <PhoneInput
//                     style={{
//                       width: "10px",
//                       marginRight: "10px",
//                     }}
//                     inputProps={{
//                       name: "phone",
//                       autoFocus: true,
//                       disabled: true,
//                       // placeholder: "Enter country code",
//                     }}
//                     country={"in"} // Default country
//                     value={formData.country_code1}
//                     onChange={handleCodeChange}
//                     inputStyle={{
//                       width: "100px", // Adjust width to fit country code
//                       height: "38px",
//                       //padding: "0.375rem 2.2rem", // Adjust padding to fit correctly
//                       paddingLeft: "3rem",
//                       fontSize: "1rem",
//                       lineHeight: "1.5",
//                       color: "#495057",
//                       backgroundColor: "#fff",
//                       backgroundClip: "padding-box",
//                       border: "1px solid #ced4da",
//                       borderRadius: ".25rem",
//                       transition:
//                         "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
//                     }}
//                     enableAreaCodes={false}
//                   />
//                   <Input
//                     // type="number"
//                     className="form-control form-control-sm"
//                     placeholder="Enter primary phone number"
//                     id="phone1"
//                     name="phone1"
//                     value={formData.phone1}
//                     onWheel={(e) => e.target.blur()} // Prevents the number input from showing the spinner

//                     onInput={(e) => {
//                       const value = e.target.value;
//                       // Check if the value is a valid number and respects phoneNumberMaxLength
//                       if (
//                         (value === "" || /^[0-9]*$/.test(value)) && // Allow only digits
//                         value.length <= phoneNumberMaxLength // Limit based on phoneNumberMaxLength
//                       ) {
//                         handleChange(e); // Call your existing handleChange function
//                       }
//                     }}
//                     style={{ marginLeft: "95px" }} // Add margin to separate the fields
//                   />
//                 </div>

//                 {errors.phone1 && (
//                   <small className="text-danger">{errors.phone1}</small>
//                 )}
//               </FormGroup>
//             </Col>

//             <Col md={6}>
//               <FormGroup>
//                 <Label for="email1">
//                   Primary Email<span className="text-danger">*</span>
//                 </Label>
//                 <Input
//                   className="form-control form-control-sm"
//                   type="text"
//                   name="email1"
//                   id="email1"
//                   placeholder="Enter primary email"
//                   value={formData.email1}
//                   onChange={handleChange}
//                   maxLength={50}
//                 />
//                 {errors.email1 && (
//                   <small className="text-danger">{errors.email1}</small>
//                 )}
//               </FormGroup>
//             </Col>
//           </Row>

//           <Row>
//             <Col md={6}>
//               <FormGroup>
//                 <Label>Secondary Phone</Label>
//                 <div className="d-flex">
//                   <PhoneInput
//                     style={{
//                       width: "10px",
//                       marginRight: "10px",
//                     }}
//                     inputProps={{
//                       name: "phone",
//                       autoFocus: true,
//                       disabled: true,
//                       // placeholder: "Enter country code",
//                     }}
//                     country={"in"} // Default country
//                     value={formData.country_code2}
//                     onChange={handleCodeChange2}
//                     inputStyle={{
//                       width: "100px", // Adjust width to fit country code
//                       height: "38px",
//                       //padding: "0.375rem 2.2rem", // Adjust padding to fit correctly
//                       paddingLeft: "3rem",
//                       fontSize: "1rem",
//                       lineHeight: "1.5",
//                       color: "#495057",
//                       backgroundColor: "#fff",
//                       backgroundClip: "padding-box",
//                       border: "1px solid #ced4da",
//                       borderRadius: ".25rem",
//                       transition:
//                         "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
//                     }}
//                     enableAreaCodes={false}
//                   />
//                   <Input
//                     // type="number"
//                     className="form-control form-control-sm"
//                     placeholder="Enter secondary phone number"
//                     id="phone2"
//                     name="phone2"
//                     value={formData.phone2}
//                     onWheel={(e) => e.target.blur()} // Prevents the number input from showing the spinner
//                     onInput={(e) => {
//                       const value = e.target.value;
//                       // Check if the value is a valid number and respects phoneNumberMaxLength
//                       if (
//                         (value === "" || /^[0-9]*$/.test(value)) && // Allow only digits
//                         value.length <= phoneNumber2MaxLength // Limit based on phoneNumberMaxLength
//                       ) {
//                         handleChange(e); // Call your existing handleChange function
//                       }
//                     }}
//                     style={{ marginLeft: "95px" }} // Add margin to separate the fields
//                   />
//                 </div>

//                 {errors.phone2 && (
//                   <small className="text-danger">{errors.phone2}</small>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col md={6}>
//               <FormGroup>
//                 <Label for="email2">Secondary Email</Label>
//                 <Input
//                   className="form-control form-control-sm"
//                   type="text"
//                   name="email2"
//                   id="email2"
//                   placeholder="Enter secondary email"
//                   value={formData.email2}
//                   onChange={handleChange}
//                   maxLength={50}
//                 />
//                 {errors.email2 && (
//                   <small className="text-danger">{errors.email2}</small>
//                 )}
//               </FormGroup>
//             </Col>
//           </Row>
//           <Row>
//             <Label>
//               Relevant Experience <span className="font-danger">*</span>
//             </Label>
//             <Col md={6}>
//               <FormGroup>
//                 <Select
//                   options={experienceOptions}
//                   value={formData.relevant_experience_years}
//                   onChange={(selectedOption) => {
//                     setFormData({
//                       ...formData,
//                       relevant_experience_years: selectedOption,
//                     });
//                     setErrors({ ...errors, relevant_experience_years: "" });
//                   }}
//                 />
//                 {errors.relevant_experience_years && (
//                   <small className="text-danger">
//                     {errors.relevant_experience_years}
//                   </small>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col md={6}>
//               <FormGroup>
//                 <Select
//                   options={monthsOptions}
//                   value={formData.relevant_experience_months}
//                   onChange={(selectedOption) => {
//                     setFormData({
//                       ...formData,
//                       relevant_experience_months: selectedOption,
//                     });
//                     setErrors({ ...errors, relevant_experience_years: "" });
//                   }}
//                 />
//               </FormGroup>
//             </Col>
//           </Row>
//         </CardBody>
//         <CardFooter className="text-end">
//           <Button
//             color="secondary"
//             type="submit"
//             name="submit"
//             className="me-1"
//             disabled={addCandidateReducerData.isLoading}
//           >
//             Submit
//           </Button>
//           <Button
//             color="primary"
//             type="submit"
//             name="update"
//             disabled={addCandidateReducerData.isLoading}
//           >
//             Update More
//           </Button>
//         </CardFooter>
//       </Card>
//     </Form>
//   );
// };

// export default AddCandidate;

import React, { useState, useEffect, useCallback, useContext } from "react";
import Select from "react-select";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Card,
  CardBody,
  CardFooter,
  Row,
  Col,
  Input,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addCandidate,
  fetchCandidateRequest,
  resetAddCandidate,
} from "../../../redux/recruiter/add_candidate/actions";
import { fetchLocationsRequest } from "../../../redux/location/actions";
import { showToast } from "../../../Components/Common/Toast";
import { useParams, useNavigate } from "react-router-dom";
import {
  customOptionsStyle,
  experienceOptions,
  monthsOptions,
} from "../../../Constant";
import { resumeDataRequest } from "../../../redux/jobseeker/get_resume_data/actions";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import {
  extractAfterLastHyphen,
  countryPhoneLengthMap,
} from "../../Common/CommonFunction";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Import styles directly from react-phone-input-2
import validator from "validator";
import { AuthContext } from "../../../Auth/AuthContext";

const AddCandidate = () => {
  const dispatch = useDispatch();
  const { triggerTotalPoints } = useContext(AuthContext);
  const { job_id, cand_id } = useParams();
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(10);
  const [phoneNumber2MaxLength, setPhoneNumber2MaxLength] = useState(10);
  const navigate = useNavigate();
  const [locationOptions, setLocationOptions] = useState([]);
  // State to hold the uploaded resume file
  const [resumeFile, setResumeFile] = useState(null);
  const [formData, setFormData] = useState({
    full_name: "",
    email1: "",
    email2: "",
    country_code1: "91",
    country_code2: "91",
    phone1: "",
    phone2: "",
    jobseeker_location: null,
    relevant_experience_years: null,
    relevant_experience_months: null,
    education: [],
    experience: [],
    skills: null,
    social_links: null

  });

  // Resume data from the store
  const resumeData = useSelector((state) => state.getResumeDataReducer);
  console.log("resumeDatarr", resumeData);
  useEffect(() => {
    if (resumeData && resumeData.data) {
      const resume = resumeData.data;
      setFormData(prev => ({
        ...prev,
        education: resume.education || [],
        experience: resume.experience || [],
        skills: resume.skills || '',
        social_links: resume.social_links || '',
        full_name: resume.full_name || '',
        email1: resume.email1 || '',
        email2: resume.email2 || '',
        phone1: resume.phone1 || '',
        phone2: resume.phone2 || '',
        jobseeker_location: resume.jobseeker_location ? {
          value: resume.jobseeker_location.value,
          label: resume.jobseeker_location.label
        } : null,
        relevant_experience_years: resume.relevant_experience_years ? {
          value: resume.relevant_experience_years.value,
          label: `${resume.relevant_experience_years.label} years`
        } : null,
        relevant_experience_months: resume.relevant_experience_months ? {
          value: resume.relevant_experience_months.value,
          label: `${resume.relevant_experience_months.label} months`
        } : null

      }));
    }
  }, [resumeData]);

  const [errors, setErrors] = useState({});
  const addCandidateReducerData = useSelector(
    (state) => state.addCandidateReducer
  );

  // Fetching and updating location data
  let locationReducerData = useSelector((state) => state.locationReducer);
  let locationData = locationReducerData.data.data;

  useEffect(() => {
    locationData = locationData || [];
    setLocationOptions(locationData);
  }, [locationData]);

  const handleLocationFocus = () => {
    const fetchData = async () => {
      try {
        const keyword = "";
        dispatch(fetchLocationsRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  };

  const handleLocationInputChange = useCallback((inputValue) => {
    const fetchData = async () => {
      try {
        dispatch(fetchLocationsRequest(inputValue));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleLocationsChange = (selectedOptions) => {
    const updatedErrors = { ...errors, jobseeker_location: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, jobseeker_location: selectedOptions });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedErrors = { ...errors, [name]: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, [name]: value });
  };

  const handleResumeUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedExts = ["pdf", "doc", "docx", "txt"];
      const ext = file.name.split(".").pop().toLowerCase();
      if (!allowedExts.includes(ext)) {
        showToast("error", "Invalid file format! Allowed formats: PDF, DOC, DOCX, TXT.");
        e.target.value = "";
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showToast("error", "File size exceeds 5MB limit.");
        e.target.value = "";
        return;
      }
      setResumeFile(file); // Store the file in state
      // Dispatch action to fetch candidate data based on the uploaded resume
      dispatch(resumeDataRequest(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name } = e.nativeEvent.submitter;

    if (validate()) {
      // const payload = {
      //   jobseeker_full_name: formData.full_name,
      //   jobseeker_email1: formData.email1,
      //   jobseeker_email2: formData.email2,
      //   country_code1: formData.country_code1,
      //   country_code2: formData.country_code2,
      //   jobseeker_phone1: formData.phone1,
      //   jobseeker_phone2: formData.phone2,
      //   jobseeker_location: formData.jobseeker_location
      //     ? formData.jobseeker_location.value
      //     : null,
      //   month_exp: formData.relevant_experience_months
      //     ? formData.relevant_experience_months.value
      //     : null,
      //   year_exp: formData.relevant_experience_years
      //     ? formData.relevant_experience_years.value
      //     : null,
      //   job_id: extractAfterLastHyphen(job_id),
      //   type: name,
      //   resume: resumeFile // Include the resume file in the payload
      // };


      // Create FormData object
      const formDataToSend = new FormData();
      // Append all form fields from the state
      formDataToSend.append('jobseeker_full_name', formData.full_name);
      formDataToSend.append('jobseeker_email1', formData.email1);
      formDataToSend.append('jobseeker_email2', formData.email2);
      formDataToSend.append('country_code1', formData.country_code1);
      formDataToSend.append('country_code2', formData.country_code2);
      formDataToSend.append('jobseeker_phone1', formData.phone1);
      formDataToSend.append('jobseeker_phone2', formData.phone2);
      formDataToSend.append('jobseeker_location', formData.jobseeker_location?.value || '');
      formDataToSend.append('month_exp', formData.relevant_experience_months?.value || '');
      formDataToSend.append('year_exp', formData.relevant_experience_years?.value || '');
      formDataToSend.append('job_id', extractAfterLastHyphen(job_id));
      formDataToSend.append('type', name);
      formDataToSend.append('education', JSON.stringify(formData.education || []));
      formDataToSend.append('experience', JSON.stringify(formData.experience || []));
      formDataToSend.append('skills', formData.skills || '');
      formDataToSend.append('social_links', JSON.stringify(formData.social_links || {}));


      // Append the resume file if it exists
      if (resumeFile) {
        formDataToSend.append('resume', resumeFile);
      }

      dispatch(addCandidate(formDataToSend));
    } else {
      console.error("Form submission error:", errors);
    }
  };

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!formData.full_name) {
      errors.full_name = "Full name is required";
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,6}$/;
    if (!formData.email1) {
      errors.email1 = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email1)) {
      errors.email1 = "Please enter valid email";
      isValid = false;
    }

    if (formData.email2 && !emailRegex.test(formData.email2)) {
      errors.email2 = "Please enter valid email";
      isValid = false;
    }


    const trimmedPhoneNumber = formData.phone1.trim();
    if (!trimmedPhoneNumber) {
      errors.phone1 = "Phone number is required";
      isValid = false;
    } else if (/^[0-5]/.test(trimmedPhoneNumber)) {
      errors.phone1 = "Phone number cannot start with 0 to 5";
      isValid = false;
    } else if (
      formData.country_code1 === "91" &&
      trimmedPhoneNumber.length !== 10
    ) {
      errors.phone1 = "Phone number must be 10 digits for India";
      isValid = false;
    } else if (isNaN(trimmedPhoneNumber)) {
      errors.phone1 = "Phone number must be a valid number";
      isValid = false;
    } else if (
      !validator.isMobilePhone(trimmedPhoneNumber, "any", { strictMode: false })
    ) {
      errors.phone1 = "Invalid phone number format";
      isValid = false;
    }

    const trimmedPhoneNumber2 = formData.phone2.trim();
    if (trimmedPhoneNumber2) {
      if (/^[0-5]/.test(trimmedPhoneNumber2)) {
        errors.phone2 = "Phone number cannot start with 0 to 5";
        isValid = false;
      } else if (
        formData.country_code2 === "91" &&
        trimmedPhoneNumber2.length !== 10
      ) {
        errors.phone2 = "Phone number must be 10 digits for India";
        isValid = false;
      } else if (isNaN(trimmedPhoneNumber2)) {
        errors.phone2 = "Phone number must be a valid number";
        isValid = false;
      } else if (
        !validator.isMobilePhone(trimmedPhoneNumber2, "any", {
          strictMode: false,
        })
      ) {
        errors.phone2 = "Invalid phone number format";
        isValid = false;
      }
    }

    // Check if both phone numbers are the same
    if (
      trimmedPhoneNumber &&
      trimmedPhoneNumber2 &&
      trimmedPhoneNumber === trimmedPhoneNumber2
    ) {
      errors.phone2 = "Primary and secondary phone numbers cannot be the same";
      isValid = false;
    }

    // Check if both emails are the same
    if (
      formData.email1 &&
      formData.email2 &&
      formData.email1 === formData.email2
    ) {
      errors.email2 = "Primary and secondary emails cannot be the same";
      isValid = false;
    }

    if (!formData.jobseeker_location) {
      errors.jobseeker_location = "Current location is required";
      isValid = false;
    }

    if (
      !formData.relevant_experience_years &&
      !formData.relevant_experience_months
    ) {
      errors.relevant_experience_years =
        "Relevant Experience (either in years or months) is required";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  useEffect(() => {
    console.log("addCandidateReducerData:", addCandidateReducerData);
    if (
      addCandidateReducerData.status === true &&
      addCandidateReducerData.message !== ""
    ) {
      showToast("success", addCandidateReducerData.message);
      triggerTotalPoints("add_candidate", false);
      const seeker_id = addCandidateReducerData.seeker_id;
      const job_cand_id = addCandidateReducerData.job_cand_id;

      if (seeker_id && job_cand_id) {
        navigate(
          `${process.env.PUBLIC_URL}/recruiter/job_candidate_detail/edit/${seeker_id}/${job_cand_id}`
        );
      } else {
        navigate(`${process.env.PUBLIC_URL}/recruiter/manage_candidate`);
      }
      dispatch(resetAddCandidate());
    } else if (
      addCandidateReducerData.status === false &&
      addCandidateReducerData.message !== ""
    ) {
      showToast("error", addCandidateReducerData.message);
      dispatch(resetAddCandidate());
    }
  }, [addCandidateReducerData, navigate, dispatch]);

  const handleCodeChange = (value, country) => {
    const phoneNumberWithoutCode = value
      .replace(`+${country.dialCode}`, "")
      .trim();
    const formattedPhoneNumber = `+${country.dialCode}${value
      .replace(/\D/g, "")
      .slice(country.dialCode.length)}`;
    setFormData({
      ...formData,
      country_code1: country.dialCode,
      jobseeker_phone1: "",
    });
    const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15;
    setPhoneNumberMaxLength(newMaxLength);
  };

  const handleCodeChange2 = (value, country) => {
    const phoneNumberWithoutCode = value
      .replace(`+${country.dialCode}`, "")
      .trim();
    const formattedPhoneNumber = `+${country.dialCode}${value
      .replace(/\D/g, "")
      .slice(country.dialCode.length)}`;
    setFormData({
      ...formData,
      country_code2: country.dialCode,
      jobseeker_phone2: "",
    });
    const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15;
    setPhoneNumber2MaxLength(newMaxLength);
  };

  return (
    <Form onSubmit={handleSubmit} className="theme-form">
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="resumeUpload">Upload Resume</Label>
                <Input
                  type="file"
                  id="resumeUpload"
                  accept=".pdf,.doc,.docx,.txt"
                  onChange={handleResumeUpload}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="full_name">
                  Full Name
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  maxLength={50}
                  className="form-control form-control-sm"
                  type="text"
                  name="full_name"
                  id="full_name"
                  placeholder="Enter full name"
                  value={formData.full_name}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (/^[A-Za-z\s]*$/.test(value) && value.length <= 50) {
                      handleChange(e);
                    } else {
                      const updatedErrors = {
                        ...errors,
                        full_name: "Only alphabetic characters are allowed.",
                      };
                      setErrors(updatedErrors);
                    }
                  }}
                />
                {errors.full_name && (
                  <small className="text-danger">{errors.full_name}</small>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>
                  Current Location
                  <span className="text-danger">*</span>
                </Label>
                <Select
                  name="jobseeker_location"
                  options={locationOptions}
                  isLoading={locationReducerData.isLoading}
                  placeholder="Select locations..."
                  value={formData.jobseeker_location}
                  onChange={handleLocationsChange}
                  onInputChange={handleLocationInputChange}
                  styles={customOptionsStyle}
                  onFocus={handleLocationFocus}
                />
                {errors.jobseeker_location && (
                  <small className="text-danger">
                    {errors.jobseeker_location}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Primary Phone
                  <span className="text-danger">*</span>
                </Label>
                <div className="d-flex">
                  <PhoneInput
                    style={{
                      width: "10px",
                      marginRight: "10px",
                    }}
                    inputProps={{
                      name: "phone",
                      autoFocus: true,
                      disabled: true,
                    }}
                    country={"in"}
                    value={formData.country_code1}
                    onChange={handleCodeChange}
                    inputStyle={{
                      width: "100px",
                      height: "38px",
                      paddingLeft: "3rem",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      color: "#495057",
                      backgroundColor: "#fff",
                      backgroundClip: "padding-box",
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                    enableAreaCodes={false}
                  />
                  <Input
                    className="form-control form-control-sm"
                    placeholder="Enter primary phone number"
                    id="phone1"
                    name="phone1"
                    value={formData.phone1}
                    onWheel={(e) => e.target.blur()}
                    onInput={(e) => {
                      const value = e.target.value;
                      if (
                        (value === "" || /^[0-9]*$/.test(value)) &&
                        value.length <= phoneNumberMaxLength
                      ) {
                        handleChange(e);
                      }
                    }}
                    style={{ marginLeft: "95px" }}
                  />
                </div>
                {errors.phone1 && (
                  <small className="text-danger">{errors.phone1}</small>
                )}
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="email1">
                  Primary Email<span className="text-danger">*</span>
                </Label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  name="email1"
                  id="email1"
                  placeholder="Enter primary email"
                  value={formData.email1}
                  onChange={handleChange}
                  maxLength={50}
                />
                {errors.email1 && (
                  <small className="text-danger">{errors.email1}</small>
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Secondary Phone</Label>
                <div className="d-flex">
                  <PhoneInput
                    style={{
                      width: "10px",
                      marginRight: "10px",
                    }}
                    inputProps={{
                      name: "phone",
                      autoFocus: true,
                      disabled: true,
                    }}
                    country={"in"}
                    value={formData.country_code2}
                    onChange={handleCodeChange2}
                    inputStyle={{
                      width: "100px",
                      height: "38px",
                      paddingLeft: "3rem",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      color: "#495057",
                      backgroundColor: "#fff",
                      backgroundClip: "padding-box",
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                    enableAreaCodes={false}
                  />
                  <Input
                    className="form-control form-control-sm"
                    placeholder="Enter secondary phone number"
                    id="phone2"
                    name="phone2"
                    value={formData.phone2}
                    onWheel={(e) => e.target.blur()}
                    onInput={(e) => {
                      const value = e.target.value;
                      if (
                        (value === "" || /^[0-9]*$/.test(value)) &&
                        value.length <= phoneNumber2MaxLength
                      ) {
                        handleChange(e);
                      }
                    }}
                    style={{ marginLeft: "95px" }}
                  />
                </div>
                {errors.phone2 && (
                  <small className="text-danger">{errors.phone2}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="email2">Secondary Email</Label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  name="email2"
                  id="email2"
                  placeholder="Enter secondary email"
                  value={formData.email2}
                  onChange={handleChange}
                  maxLength={50}
                />
                {errors.email2 && (
                  <small className="text-danger">{errors.email2}</small>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label>
              Relevant Experience <span className="font-danger">*</span>
            </Label>
            <Col md={6}>
              <FormGroup>
                <Select
                  options={experienceOptions}
                  value={formData.relevant_experience_years}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      relevant_experience_years: selectedOption,
                    });
                    setErrors({ ...errors, relevant_experience_years: "" });
                  }}
                />
                {errors.relevant_experience_years && (
                  <small className="text-danger">
                    {errors.relevant_experience_years}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Select
                  options={monthsOptions}
                  value={formData.relevant_experience_months}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      relevant_experience_months: selectedOption,
                    });
                    setErrors({ ...errors, relevant_experience_years: "" });
                  }}
                />
              </FormGroup>
            </Col>
          </Row>

        </CardBody>
        <CardFooter className="text-end">
          <Button
            color="secondary"
            type="submit"
            name="submit"
            className="me-1"
            disabled={addCandidateReducerData.isLoading}
          >
            Submit
          </Button>
          <Button
            color="primary"
            type="submit"
            name="update"
            disabled={addCandidateReducerData.isLoading}
          >
            Update More
          </Button>
        </CardFooter>
      </Card>
    </Form>
  );
};

export default AddCandidate;

